import type { RemoteEvent } from "./protocol";

const API_BASE = (import.meta.env.VITE_API_BASE_URL as string).replace(/\/$/, "");

export async function joinRoom(roomId: string, password: string): Promise<string> {
  const res = await fetch(`${API_BASE}/api/join`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ roomId, password }),
  });
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(`join failed: ${res.status} ${txt}`);
  }
  const data = (await res.json()) as { token?: string };
  if (!data.token) throw new Error("join response missing token");
  return data.token;
}

export function connectControlWs(
  roomId: string,
  token: string,
  onOpen?: () => void,
  onClose?: () => void
): (event: RemoteEvent) => void {
  const wsBase = API_BASE.replace(/^http/, "ws");
  const ws = new WebSocket(
    `${wsBase}/api/ws?roomId=${encodeURIComponent(roomId)}&token=${encodeURIComponent(token)}&role=client`
  );
  ws.onopen = () => onOpen?.();
  ws.onclose = () => onClose?.();

  return (event: RemoteEvent) => {
    if (ws.readyState === WebSocket.OPEN) {
      ws.send(JSON.stringify({ type: "control", payload: event }));
    }
  };
}

